import { Box, Typography, Grid, Divider } from "@mui/material";

import KeyStat from "../Numbers/KeyStat";
import InProgress from "../InProgress";

export default function KeyStats(props) {
    const mySettings = props.mySettings
    const sidebarSettings = props.sidebarSettings

    return (
        <Box sx={{ height: "25%", margin: "16px" }}>
            {sidebarSettings.schools ?
                <KeyStat stat={sidebarSettings.schools.length - 1} label="schools" variant="h6" color="black" />
                : null
            }
            <Divider sx={{ margin: "16px 0 6px 0" }} />
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <Typography variant="body1" sx={{ fontWeight: "700" }}>Utilization</Typography>
                    <KeyStat stat={"XX"} label="well-utilized" variant="body1" color="black" />
                    <Typography variant="body2" color="grey.main">80%-95% of capacity</Typography>
                    <KeyStat stat={"XX"} label="over-utilized" variant="body1" color="black" />
                    {/* <Typography variant="body2" color="grey.main">{`>95% of capacity`}</Typography> */}
                    <KeyStat stat={"XX"} label="under-utilized" variant="body1" color="black" />
                    {/* <Typography variant="body2" color="grey.main">{`<80% of capacity`}</Typography> */}
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Typography variant="body1" sx={{ fontWeight: "700" }}>Distance to school</Typography>
                    <KeyStat stat={"XX"} label="pupil miles per day" variant="body1" color="black" />
                    <KeyStat stat="XX%" label="pupils in walk zone" variant="body1" color="black" />
                </Grid>
            </Grid>
            {/* <InProgress message="Key stats panel in progress" /> */}
        </Box>
    )
}